<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">รายการสินค้าใกล้หมดคลัง</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12" class="title_page_center_right">
          <div style="float: right;">
            <v-badge class="text-center" color="error" :content="count_cart" overlap>
              <v-btn elevation="3" height="45" @click="link('/arin/pos/cartlist')" class="white--text"
                style="border-radius: 10px;background-color: #D6BFAF !important;">
                <v-icon size="32">mdi-cart</v-icon>
              </v-btn>
            </v-badge>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
          <v-card elevation="4" style="border-radius: 15px;">
            <v-card-title>
              <v-row>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <div>รายการสินค้าใกล้หมดคลัง</div>
                </v-col>
                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                  <v-text-field color="#D6BFAF" class="input-radius inp-text-field" append-icon="mdi-magnify"
                    style="float: right;" hide-details="auto" required v-model="search"  @keyup="searchProductList()" placeholder="ค้นหา..."
                    single-line outlined dense></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-data-table :headers="headers" :items="data_list"
                    mobile-breakpoint="0"  :hide-default-footer="true">
                    <template v-slot:item="dataDetail">
                      <tr>
                        <td class="pa-3">
                          <div><v-img height="80" max-width="80" :lazy-src="dataDetail.item.picture"
                              :src="dataDetail.item.picture" class="preview"></v-img></div>
                        </td>
                        <td>
                          <div>{{ dataDetail.item.name }}</div>
                          <div class="grey--text"><small>{{ dataDetail.item.sub_name }}</small></div>
                          <div class="d-flex justify-content-start">
                            <div v-for="item in dataDetail.item.unitList" :key="item.id">
                              <div class="ma-2 tag_border_unit"
                                :class="{ 'tag_border_unit_active': item.status !== false }" @click="selectUnit(dataDetail.item,dataDetail.item.unitList,item)">
                                {{ item.name }}</div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="text-center" :style="parseFloat(dataDetail.item.min) > parseFloat(dataDetail.item.in_stock) ? 'color:#ff5252;' : ''">{{ formatPrice(dataDetail.item.in_stock) }}</div>
                        </td>
                        <td>
                          <div class="text-center">฿ {{ formatPrice(dataDetail.item.price) }}</div>
                        </td>
                        <td>
                          <div class="d-flex justify-center">
                            <v-btn class="mt-1" color="#D6BFAF" height="17px" width="17px"
                              style="border-radius: 5px;border-color:#D6BFAF;"
                              @click="subtractQuantity(dataDetail.item)" fab x-small dark outlined>
                              <v-icon>mdi-minus</v-icon>
                            </v-btn>
                            <p class="ml-2 mr-2"> {{ dataDetail.item.countProduct }}</p>
                            <v-btn class="mt-1" color="#D6BFAF" height="17px" width="17px"
                              style="border-radius: 5px;border-color:#D6BFAF;" @click="addQuantity(dataDetail.item)" fab
                              x-small dark outlined>
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                        </td>
                        <td>
                          <div class="text-center">฿ {{ formatPrice(dataDetail.item.sumPrice) }}</div>
                        </td>
                        <td class="">
                            <v-btn elevation="3" class="ma-2" outlined small height="45" color="#D6BFAF"
                              style="border-radius: 10px;background-color: #FFFFFF" title="เพิ่มลงตะกร้า" @click="addCart(dataDetail.item)">
                              <v-icon>mdi-cart-outline</v-icon>
                            </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                  <div class="d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                      <div class="mr-2">Rows per page:</div>
                      <div style="width:20%">
                        <v-select class="pa-0 ma-0" color="#D6BFAF" :items="size_list" item-text="name" item-value="id" v-model="size" hide-details="auto"></v-select>
                      </div>
                    </div>
                    <div style="width:30%">
                      <v-pagination class="pagination_arin" v-model="page" color="#D6BFAF" :length="count_page"></v-pagination>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import img_holder from "@/assets/arin_assets/image_sun_color.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_product_list",
  data() {
    return {
      loading_page: false,
       page: 1,
      size: 10,
      type: null,
      count_cart: '0',
      search: '',
      img_holder: img_holder,
      product_type_list: [
        { id: 1, name: 'ทั้งหมด' },
      ],
      product_type: '',
      promotion_list: [
        { id: 1, name: 'โปรโมชั่น' },
      ],
      promotion_type: '',
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'ออกใบสั่งซื้อ',
          disabled: false,
        },
        {
          text: 'รายการสินค้า',
          disabled: false,
        },
        {
          text: 'รายการสินค้าใกล้หมดคลัง',
          disabled: false,
          href: '#',
        },

      ],
      headers: [
        {
          text: 'รูปภาพ',
          value: '',
          fixed: true,
          width: '120px',
          sortable: false,
          align: 'left',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '300px',
          align: 'left',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'in_stock',
          fixed: true,
          width: '300px',
          align: 'center',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          width: '160px',
          align: 'center',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          width: '120px',
          align: 'center',
        },
        {
          text: 'ราคารวม',
          value: '',
          fixed: true,
          width: '160px',
          align: 'center',
        },
        {
          text: 'หยิบใส่ตระกร้า',
          value: '',
          fixed: true,
          width: '60px',
          sortable: false,
          align: 'left',
        },
      ],
      data_list: [],
      size_list:[
        { id: 5, name: '5' },
        { id: 10, name: '10' },
        { id: 15, name: '15' },
        { id: 'all', name: 'All' },
      ],
    }
  },
  methods: {
    link(link_url) {
      this.$router.push(link_url)
    },
    formatPrice(number){
      return formatPrice(number)
    },
    addQuantity(item) {
      this.data_list[item.index].sumPrice = parseInt(this.data_list[item.index].sumPrice) + parseInt(item.price);
     if (item.countProduct >= 0) {
        item.countProduct++;
        const data = {
          product_id: item.id,
          unit_id: item.unit_id,
          quantity: item.countProduct,
        }
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.post('/pos/product/check/special/price', data ,config).then((res) => {
            if (res.data.successful === true) {
              item.price = res.data.cost
            }
        })
      }
    },
    subtractQuantity(item) {
      if (item.countProduct > 0) {
        item.countProduct--;
        const data = {
          product_id: item.id,
          unit_id: item.unit_id,
          quantity: item.countProduct,
        }
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.post('/pos/product/check/special/price', data ,config).then((res) => {
            if (res.data.successful === true) {
              item.price = res.data.cost
               this.data_list[item.index].sumPrice = parseInt(this.data_list[item.index].sumPrice) - parseInt(item.price);
            }
        })
      }
    },
    selectUnit(item,unit_item_list,unit_item){
      let num_unit_item_list = unit_item_list.length
      for (let index = 0; index < num_unit_item_list; index++) {
        unit_item_list[index].status = false
      }
      unit_item.status = true
      item.unit_id = unit_item.unit_id
      item.price = unit_item.price
      item.weight = unit_item.weight
      this.data_list[item.index].sumPrice = 0;
      this.data_list[item.index].sumPrice = parseInt(this.data_list[item.index].countProduct) * parseInt(item.price);
    },
      async getProductList() {
      this.loading_page = true;
      this.data_list = [];
      this.type = null;
      const data = {
        search : this.search,
        product_type : this.product_type,
        promotion_type : this.promotion_type,
        page : this.page,
        size : this.size
      };
      
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.post('/pos/products/less/stock' , data,config).then((res) => {

          if (res.data.successful === true) {
              this.count_page = res.data.count_page
              const num_product = res.data.product.length
              for (let index = 0; index < num_product; index++) {
                let unit_list = []
                let num_unit = res.data.product[index].unitList.length
                let unit_id = null
                let price = null
                let weight = null
                for (let index_unit = 0; index_unit < num_unit; index_unit++) {
                  unit_list.push({
                    unit_id: res.data.product[index].unitList[index_unit].unit_id,
                    name: res.data.product[index].unitList[index_unit].name,
                    price: res.data.product[index].unitList[index_unit].price,
                    weight: res.data.product[index].unitList[index_unit].weight,
                    status: index_unit != 0 ? false : true,
                  })
                  if (index_unit == 0) {
                    unit_id = res.data.product[index].unitList[index_unit].unit_id
                    price = res.data.product[index].unitList[index_unit].price
                    weight = res.data.product[index].unitList[index_unit].weight
                  }
                }
                this.data_list.push({
                  id: res.data.product[index].id,
                  picture: res.data.product[index].picture,
                  name: res.data.product[index].name,
                  name_sci: res.data.product[index].name_sci,
                  unitList: unit_list,
                  unit_id: unit_id,
                  price: price,
                  weight: weight,
                  quantity: 0,
                  in_stock: res.data.product[index].in_stock,
                  min: res.data.product[index].min,
                  index:index,
                  countProduct: 0,
                   sumPrice: 0,
                })
              }
              this.type = res.data.type;
              this.loading_page = false;
          }
      })
    },
     async countCart(){
      this.count_cart = '0';
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/count/cart' ,config).then((res) => {
          if (res.data.successful === true) {
            this.count_cart = res.data.count.toString()
          }
      })
    },async searchProductList() {
      this.data_list = [];
      this.type = null;
      const data = {
        search : this.search,
        product_type : this.product_type,
        promotion_type : this.promotion_type,
        page : this.page,
        size : this.size
      };
      
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.post('/pos/products/less/stock' , data,config).then((res) => {

          if (res.data.successful === true) {
              this.count_page = res.data.count_page
              const num_product = res.data.product.length
              for (let index = 0; index < num_product; index++) {
                let unit_list = []
                let num_unit = res.data.product[index].unitList.length
                let unit_id = null
                let price = null
                let weight = null
                for (let index_unit = 0; index_unit < num_unit; index_unit++) {
                  unit_list.push({
                    unit_id: res.data.product[index].unitList[index_unit].id,
                    name: res.data.product[index].unitList[index_unit].name,
                    price: res.data.product[index].unitList[index_unit].price,
                    weight: res.data.product[index].unitList[index_unit].weight,
                    status: index_unit != 0 ? false : true,
                  })
                  if (index_unit == 0) {
                    unit_id = res.data.product[index].unitList[index_unit].unit_id
                    price = res.data.product[index].unitList[index_unit].price
                    weight = res.data.product[index].unitList[index_unit].weight
                  }
                }
                this.data_list.push({
                  id: res.data.product[index].id,
                  picture: res.data.product[index].picture,
                  name: res.data.product[index].name,
                  name_sci: res.data.product[index].name_sci,
                  unitList: unit_list,
                  unit_id: unit_id,
                  price: price,
                  weight: weight,
                  quantity: 0,
                  in_stock: res.data.product[index].in_stock,
                  index:index,
                  countProduct: 0,
                   sumPrice: 0,
                })
              }
              this.type = res.data.type;
          }
      })
    },
    async addCart(detail){
      if (detail.countProduct > 0) {
        const data = {
          type: this.type,
          product_id: detail.id,
          unit_id: detail.unit_id,
          quantity: detail.countProduct,
          cost: detail.price,
          total: detail.price * detail.countProduct,
          weight: detail.weight,
        }
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        HTTP_ARIN.post('/pos/add/to/cart', data ,config).then((res) => {
          if (res.data.successful === true) {
            detail.countProduct = 0
            this.countCart()
          }
        })
      }
    }
  },
  mounted(){
    this.getProductList();
    this.countCart();
  },
  watch:{
   async page(){
    this.getProductList();
    },
    async size(){
        this.getProductList()
      },
  }
}
</script>

<style scoped>
.grid_three {
  display: grid;
  grid-template-columns: 33.33% 33.33% 33.34%;
}

.input-radius {
  border-radius: 10px;
}

.preview {
  border-radius: 10px;
  margin: auto;
}

.width>>>input {
  max-width: 100%;
  text-align: center;
}


@media only screen and (min-width: 0px)AND (max-width: 361px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100% !important;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (max-width: 600px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_add_data_submit {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    width: 100%;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (min-width: 601px) AND (max-width: 960px) {
  .inp-text-field {
    width: 100%;
  }

  .btn_exp_list {
    width: 100%;
  }
}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {
  .inp-text-field {
    width: 50%;
  }
}


/* @media only screen and (min-width: 1265px) AND (max-width: 1904px) {
  .inp-text-field {
    width: 23%;
  }
} */
</style>
